import { InboxEntry } from '../../models/inbox-entry.model';

export type AufgabenArt = 'uebergabe' | 'testlauf' | 'review' | 'abweichung';

export type Faelligkeit = 'ueberfaellig' | 'heute' | 'morgen' | 'woche';

export interface AufgabenArtInfo {
  art: AufgabenArt;
  labelKey: string;
  aktionKey: string;
  icon: string;
}

export const AUFGABEN_ARTEN: readonly AufgabenArtInfo[] = [
  {
    art: 'uebergabe',
    labelKey: 'home.aufgaben.arten.uebergabe',
    aktionKey: 'home.aufgaben.liste.aktion.uebergabe',
    icon: 'chevron_right',
  },
  {
    art: 'testlauf',
    labelKey: 'home.aufgaben.arten.testlauf',
    aktionKey: 'home.aufgaben.liste.aktion.testlauf',
    icon: 'bar_chart',
  },
  {
    art: 'review',
    labelKey: 'home.aufgaben.arten.review',
    aktionKey: 'home.aufgaben.liste.aktion.review',
    icon: 'visibility',
  },
  {
    art: 'abweichung',
    labelKey: 'home.aufgaben.arten.abweichung',
    aktionKey: 'home.aufgaben.liste.aktion.abweichung',
    icon: 'bug_report',
  },
];

export function artInfo(art: AufgabenArt): AufgabenArtInfo {
  return AUFGABEN_ARTEN.find((a) => a.art === art)!;
}

export function artVon({ kind, entityType }: Pick<InboxEntry, 'kind' | 'entityType'>): AufgabenArt | null {
  switch (kind) {
    case 'uebergabe':
    case 'ergaenzen':
      return 'uebergabe';
    case 'testlauf':
      return 'testlauf';
    case 'review':
      return 'review';
    case 'fehler':
      return entityType === 'defect' ? 'abweichung' : null;
    default:
      return null;
  }
}

const TAG_MS = 24 * 60 * 60 * 1000;

export function faelligkeit(dueAt: string | null, heute: Date): Faelligkeit | null {
  if (!dueAt) return null;
  const [jahr, monat, tag] = dueAt.split('-').map(Number);
  // new Date('YYYY-MM-DD') wäre Mitternacht UTC und verschöbe den Tag je nach Zeitzone.
  const faellig = new Date(jahr, monat - 1, tag);
  const heuteBeginn = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
  const tage = Math.round((faellig.getTime() - heuteBeginn.getTime()) / TAG_MS);
  if (tage < 0) return 'ueberfaellig';
  if (tage === 0) return 'heute';
  if (tage === 1) return 'morgen';
  const tageBisSonntag = (7 - heuteBeginn.getDay()) % 7;
  return tage <= tageBisSonntag ? 'woche' : null;
}

const STUFEN_FOLGE: readonly (Faelligkeit | null)[] = ['ueberfaellig', 'heute', 'morgen', 'woche', null];

export function sortiereAufgaben(eintraege: readonly InboxEntry[], heute: Date): InboxEntry[] {
  const rang = (eintrag: InboxEntry) => STUFEN_FOLGE.indexOf(faelligkeit(eintrag.dueAt ?? null, heute));
  return [...eintraege].sort((a, b) => rang(a) - rang(b) || Date.parse(b.createdAt) - Date.parse(a.createdAt));
}
